import { useEffect, useMemo, useState } from 'react'
import { generateMeetingCode, normalizeMeetingCode } from '../utils/meeting-code.utils'

const READY_TO_JOIN_DELAY_MS = 3000

interface UsePreJoinFlowOptions {
  initialUserName?: string
  initialMeetingCode?: string
}

export function usePreJoinFlow({
  initialUserName = '',
  initialMeetingCode = '',
}: UsePreJoinFlowOptions) {
  const [userName, setUserName] = useState(initialUserName)
  const [meetingCode, setMeetingCode] = useState(initialMeetingCode)
  const [pendingCode, setPendingCode] = useState(initialMeetingCode)
  const [isAnimating, setIsAnimating] = useState(false)
  const [showReadyToJoin, setShowReadyToJoin] = useState(false)

  useEffect(() => {
    setIsAnimating(true)
  }, [])

  useEffect(() => {
    if (pendingCode) return
    const code = normalizeMeetingCode(generateMeetingCode())
    setPendingCode(code)
    setMeetingCode(code)
  }, [pendingCode])

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowReadyToJoin(true)
    }, READY_TO_JOIN_DELAY_MS)
    return () => window.clearTimeout(timer)
  }, [])

  const normalizedMeetingCode = useMemo(() => normalizeMeetingCode(meetingCode), [meetingCode])

  return {
    userName,
    setUserName,
    meetingCode,
    setMeetingCode,
    normalizedMeetingCode,
    pendingCode,
    isAnimating,
    showReadyToJoin,
  }
}
